"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const clsx_1 = __importDefault(require("clsx"));
require("./styles.scss");
const selected_services_list_1 = __importDefault(require("./selected-services-list"));
const remove_all_button_1 = __importDefault(require("./remove-all-button"));
const dropdown_options_1 = __importDefault(require("./dropdown-options"));
const multiselect_utils_1 = require("../../utils/multiselect-utils");
const LocationMultiselect = ({ "aria-invalid": ariaInvalid, "aria-describedby": ariaDescribedBy, htmlId, options, selectedServices, onChange, onFocus, className, lightBg }) => {
    const [open, setOpen] = (0, react_1.useState)(false);
    const [activeIndex, setActiveIndex] = (0, react_1.useState)(0);
    const [filteredOptions, setFilteredOptions] = (0, react_1.useState)([]);
    const [value, setValue] = (0, react_1.useState)("");
    const ignoreBlur = (0, react_1.useRef)(false);
    const [callFocus, setCallFocus] = (0, react_1.useState)(false);
    const inputRef = (0, react_1.useRef)(null);
    const listboxRef = (0, react_1.useRef)(null);
    const activeOptionRef = (0, react_1.useRef)(null);
    const getFilteredOptionsLength = (opts) => (opts !== null && opts !== void 0 ? opts : filteredOptions).reduce((c, cat) => { var _a, _b; return c + ((_b = (_a = cat.services) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0); }, 0);
    const activeId = open ? `${htmlId}-${activeIndex}` : "";
    const removeOption = (index) => {
        const newSelectedOptions = [...selectedServices];
        newSelectedOptions.splice(index, 1);
        onChange(newSelectedOptions);
    };
    const updateOption = (index) => {
        const option = filteredOptions.flatMap((c) => c.services)[index];
        if (!option)
            return;
        const optionIndex = selectedServices.indexOf(option);
        const isSelected = optionIndex > -1;
        if (isSelected) {
            removeOption(optionIndex);
            setValue("");
        }
        else {
            const newSelectedOptions = [...selectedServices, option];
            setFilteredOptions(options);
            setValue("");
            setActiveIndex(index);
            onChange(newSelectedOptions);
        }
        setOpen(false);
    };
    const onInput = () => {
        if (inputRef.current) {
            const curValue = inputRef.current.value;
            const opts = (0, multiselect_utils_1.filterOptions)(options, curValue);
            setFilteredOptions(opts);
            if (value !== curValue) {
                setValue(curValue);
                setActiveIndex(0);
            }
            const menuState = curValue !== "" && getFilteredOptionsLength(opts) > 0;
            if (open !== menuState) {
                setOpen(menuState);
                setCallFocus(false);
            }
        }
    };
    const onInputBlur = () => {
        var _a;
        if (ignoreBlur.current) {
            (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            ignoreBlur.current = false;
            return;
        }
        setOpen(false);
        setCallFocus(false);
    };
    const onOptionChange = (index) => {
        setActiveIndex(index);
    };
    const onOptionClick = (index) => {
        onOptionChange(index);
        updateOption(index);
    };
    const onOptionMouseDown = (index) => {
        ignoreBlur.current = true;
        setCallFocus(true);
        setActiveIndex(index);
    };
    const onInputKeyDown = (event) => {
        const max = getFilteredOptionsLength() - 1;
        const action = (0, multiselect_utils_1.getActionFromKey)(event, open);
        switch (action) {
            case multiselect_utils_1.MenuActions.Next:
            case multiselect_utils_1.MenuActions.Last:
            case multiselect_utils_1.MenuActions.First:
            case multiselect_utils_1.MenuActions.Previous:
                event.preventDefault();
                return onOptionChange((0, multiselect_utils_1.getUpdatedIndex)(activeIndex, max, action));
            case multiselect_utils_1.MenuActions.CloseSelect:
                event.preventDefault();
                return updateOption(activeIndex);
            case multiselect_utils_1.MenuActions.Close:
                event.preventDefault();
                return setOpen(false);
            case multiselect_utils_1.MenuActions.Open:
                return setOpen(true);
        }
    };
    (0, react_1.useEffect)(() => {
        setFilteredOptions((0, multiselect_utils_1.filterOptions)(options, value));
    }, [options, value]);
    (0, react_1.useEffect)(() => {
        if (inputRef.current && callFocus === true) {
            inputRef.current.focus();
            setCallFocus(false);
        }
    }, [callFocus, setCallFocus, open]);
    (0, react_1.useEffect)(() => {
        if (open && (0, multiselect_utils_1.isScrollable)(listboxRef)) {
            (0, multiselect_utils_1.maintainScrollVisibility)(activeOptionRef, listboxRef);
        }
    }, [open, activeIndex]);
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: `${className ? className : ""}` }, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ className: (0, clsx_1.default)({ multiselect: true, open }) }, { children: [(0, jsx_runtime_1.jsx)("input", { "aria-activedescendant": activeId, "aria-autocomplete": "list", "aria-controls": `${htmlId}-listbox`, "aria-expanded": open, "aria-haspopup": "listbox", "aria-labelledby": `${htmlId} ${htmlId}-selected`, "aria-invalid": ariaInvalid, "aria-describedby": ariaDescribedBy, className: "multiselect-input", style: { margin: selectedServices.length > 0 ? '0 0 1.5rem' : '0' }, ref: inputRef, role: "combobox", type: "text", value: value, onFocus: onFocus, onBlur: onInputBlur, onClick: (e) => {
                            if (e.currentTarget.value !== "")
                                setOpen(true);
                        }, onInput: onInput, onKeyDown: onInputKeyDown, id: `${htmlId}-input` }), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "multiselect-menu", role: "listbox", ref: listboxRef, "aria-multiselectable": "true", id: `${htmlId}-listbox`, onClick: () => ignoreBlur.current = true }, { children: (() => {
                            return (0, jsx_runtime_1.jsx)(dropdown_options_1.default, { htmlId: htmlId, filteredOptions: filteredOptions, activeIndex: activeIndex, selectedServices: selectedServices, onOptionClick: onOptionClick, onOptionMouseDown: onOptionMouseDown, value: value, ref: activeOptionRef });
                        })() }))] })), (0, jsx_runtime_1.jsx)(selected_services_list_1.default, { htmlId: htmlId, selectedServices: selectedServices, removeOption: removeOption, lightBg: lightBg }), selectedServices.length > 0 ? ((0, jsx_runtime_1.jsx)(remove_all_button_1.default, { onChange: () => { onChange([]); } })) : null] })));
};
exports.default = LocationMultiselect;
